import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { User, SessionService } from '@edl-development/edl-common';
import { StateService } from "@uirouter/angular";
import { initializeApp } from 'firebase/app';
import { getAuth, multiFactor, onAuthStateChanged } from 'firebase/auth';
import { Subscription } from 'rxjs';
import { SchoolYearSchedule } from 'src/app/model/school-year-schedule';

@Component({
    selector: 'authenticated-header',
    templateUrl: './authenticated-header.component.html',
    styleUrls: ['./authenticated-header.component.scss']
})

export class AuthenticatedHeaderComponent implements OnInit, OnDestroy {
    user?: User;
    activeUserSub?: Subscription;

    messagesParams!: { page: number, start: string | null, end: string | null };
    datePipe = new DatePipe('en-US');


    constructor(
        private stateService: StateService,
        private sessionService: SessionService
    ) { }

    ngOnInit() {
        this.activeUserSub = this.sessionService.activeUser.subscribe((user: User) => {
            this.user = user;
        });
        this.messagesParams = this.generateMessagesParams();

    }

    ngOnDestroy(): void {
        this.activeUserSub?.unsubscribe();
    }

    private generateMessagesParams() {
        const schoolYear = new SchoolYearSchedule();

        return {
            page: 1,
            start: this.datePipe.transform(schoolYear.StartDate, 'MM/dd/yyyy'),
            end:this.datePipe.transform(schoolYear.EndDate,'MM/dd/yyyy'),
        }
    }

    public logout() {
        this.stateService.go('public.logout');
    }
}
